// HST — modèle partagé entre la vue 3D et l'interface.
// Arbre de développement : identifiants, coûts et charges repris de l'écran « Arbre de développement ».
// Les textes d'effet (sauf P13) sont à aligner avec ceux du jeu.
// 21/10/2026 — libellés bilingues via le système i18n du jeu (clés d3_*) :
// les identifiants de paliers restent en français (clés de l'arbre), leur
// affichage passe par tierLabel().

import { tStandalone } from '../../i18n';

export const TIERS = ['Fondation', 'Structure', 'Développement', 'Spécialisation', 'Excellence'];
const TIER_KEYS = { Fondation: 'd3_tier_fondation', Structure: 'd3_tier_structure', 'Développement': 'd3_tier_developpement', 'Spécialisation': 'd3_tier_specialisation', Excellence: 'd3_tier_excellence' };
export const tierLabel = (tier) => tStandalone(TIER_KEYS[tier] || 'd3_tier_excellence');

export const DEV_TREE = [
  { id: 'P2', name: 'Agrandissement dépôt (x2)', tier: 'Fondation', icon: 'wrench', cost: 8000, monthly: 250, requires: [], effect: '+3 emplacements de stationnement, cour doublée', zone: 'cour' },
  { id: 'P3', name: 'Entrepôt dédié (location)', tier: 'Structure', icon: 'warehouse', cost: 0, monthly: 1200, requires: ['P2'], effect: 'Stockage des contrats « marchandises sèches »', zone: 'entrepôt' },
  { id: 'P4', name: 'Quai de chargement dédié', tier: 'Développement', icon: 'dock', cost: 15000, monthly: 80, requires: ['P3'], effect: '4 portes à quai, chargement plus rapide', zone: 'entrepôt' },
  { id: 'P5', name: 'Achat terrain + entrepôt', tier: 'Développement', icon: 'building', cost: 120000, monthly: 0, requires: ['P3'], effect: 'Le site devient propriété HST : fin du loyer de l’entrepôt (panneau « Propriété HST » à l’entrée)', zone: 'propriété' },
  { id: 'EXT', name: 'Extension logistique (+100 km)', tier: 'Développement', icon: 'globe', cost: 18000, monthly: 200, requires: ['P3'], effect: 'Rayon d’action des contrats étendu de 100 km (panneau à l’entrée)', zone: 'rayon d’action' },
  { id: 'P11', name: 'Atelier mécanique (siège)', tier: 'Développement', icon: 'wrench', cost: 25000, monthly: 350, requires: ['P3'], effect: 'Entretien interne, immobilisation réduite', zone: 'atelier' },
  { id: 'P14', name: 'Cuve carburant 2 000L', tier: 'Développement', icon: 'fuel', cost: 4500, monthly: 60, requires: ['P3'], effect: 'Gazole acheté en gros, coût au km réduit', zone: 'station' },
  { id: 'P6', name: 'Zone frigorifique au dépôt', tier: 'Spécialisation', icon: 'thermo', cost: 22000, monthly: 300, requires: ['P4'], effect: 'Débloque le stockage des contrats frigorifiques', zone: 'entrepôt' },
  { id: 'P7', name: 'Quai renforcé (BTP lourd)', tier: 'Spécialisation', icon: 'helmet', cost: 28000, monthly: 220, requires: ['P4'], effect: 'Chargement des matériaux BTP lourds', zone: 'entrepôt' },
  { id: 'P8', name: 'Hangar haute hauteur (T3+)', tier: 'Spécialisation', icon: 'box', cost: 45000, monthly: 600, requires: ['P4'], effect: 'Abri pour véhicules hors gabarit T3+', zone: 'hangar' },
  { id: 'P9', name: 'Borne de recharge électrique rapide', tier: 'Spécialisation', icon: 'plug', cost: 32000, monthly: 150, requires: ['P4'], effect: 'Recharge des véhicules électriques sur site', zone: 'ombrière' },
  { id: 'P10', name: 'Pompe diesel dédiée', tier: 'Spécialisation', icon: 'drop', cost: 12000, monthly: 120, requires: ['P14'], effect: 'Plein sur site, temps de mission réduit', zone: 'station' },
  { id: 'P12', name: 'Zone ADR sécurisée', tier: 'Excellence', icon: 'warning', cost: 35000, monthly: 400, requires: ['P7'], effect: 'Stockage des matières dangereuses (contrats ADR)', zone: 'zone ADR' },
  { id: 'P13', name: 'Panneaux photovoltaïques (QG)', tier: 'Excellence', icon: 'sun', cost: 35000, monthly: 0, requires: ['P9'], condition: 'Phase 4 (international)', effect: '-20 % loyer du QG (autoconsommation)', zone: 'QG' },
];

export const GOODS = {
  sec: { key: 'd3_goods_sec', zone: 'P3', bodies: ['tautliner', 'fourgon'] },
  frigo: { key: 'd3_goods_frigo', zone: 'P6', bodies: ['frigo'] },
  btp: { key: 'd3_goods_btp', zone: 'P7', bodies: ['plateau', 'benne'] },
  adr: { key: 'd3_goods_adr', zone: 'P12', bodies: ['citerne', 'tautliner'] },
  vrac: { key: 'd3_goods_vrac', zone: 'P2', bodies: ['benne', 'citerne'] },
};
export const goodsLabel = (goods) => (GOODS[goods] ? tStandalone(GOODS[goods].key) : goods);

export const BODY_KEYS = {
  tautliner: 'd3_body_tautliner', frigo: 'd3_body_frigo', citerne: 'd3_body_citerne', plateau: 'd3_body_plateau', benne: 'd3_body_benne', fourgon: 'd3_body_fourgon',
};
export const bodyLabel = (body) => (BODY_KEYS[body] ? tStandalone(BODY_KEYS[body]) : body);
const TYPE_KEYS = { semi: 'd3_type_semi', porteur: 'd3_type_porteur', vul: 'd3_type_vul' };
export const typeLabel = (type) => (TYPE_KEYS[type] ? tStandalone(TYPE_KEYS[type]) : type);
const STATUS_KEYS = { stationne: 'd3_status_stationne', mission: 'd3_status_mission', atelier: 'd3_status_atelier' };
export const statusLabel = (status) => (STATUS_KEYS[status] ? tStandalone(STATUS_KEYS[status]) : status);

export const nodeName = (id, tree = DEV_TREE) => (id === 'P1' ? tStandalone('d3_base_site') : tree.find((n) => n.id === id)?.name || id);

export function depotStats(depot, tree = DEV_TREE) {
  const built = new Set(depot.built || []);
  const vehicles = depot.vehicles || [];
  const charges = tree.filter((n) => built.has(n.id)).reduce((s, n) => s + (n.monthly || 0), 0);
  const order = tree.filter((n) => built.has(n.id));
  const last = depot.built?.length ? nodeName(depot.built[depot.built.length - 1], tree) : tStandalone('d3_base_site');
  return {
    phase: order.length,
    phases: tree.length,
    builtCount: order.length,
    total: tree.length,
    last,
    charges,
    parked: vehicles.filter((v) => v.status !== 'mission').length,
    onMission: vehicles.filter((v) => v.status === 'mission').length,
    slots: depot.slots ?? (built.has('P2') ? 7 : 4),
  };
}

// Contrôles de cohérence entre contrats, zones construites, flotte et RH
export function coherence(depot, tree = DEV_TREE) {
  const out = [];
  const built = new Set(depot.built || []);
  const vehicles = depot.vehicles || [];
  const staff = depot.staff || {};
  const name = (id) => tree.find((n) => n.id === id)?.name || id;
  (depot.contracts || []).forEach((c) => {
    const g = GOODS[c.goods];
    if (!g) return;
    if (g.zone && !built.has(g.zone)) out.push({ level: 'warn', topic: 'contrat', id: c.id, zone: g.zone, text: tStandalone('d3_coh_goods_without_zone', { client: c.client, goods: goodsLabel(c.goods).toLowerCase(), zone: name(g.zone) }) });
    if (!vehicles.some((v) => g.bodies.includes(v.body || (v.type === 'vul' ? 'fourgon' : 'tautliner')))) out.push({ level: 'warn', topic: 'flotte', id: c.id, text: tStandalone('d3_coh_no_vehicle', { client: c.client, bodies: g.bodies.map(bodyLabel).join(' / ') }) });
  });
  const st = depotStats(depot, tree);
  if (vehicles.length - st.onMission > st.slots) out.push({ level: 'warn', topic: 'flotte', text: tStandalone('d3_coh_no_slot', { n: vehicles.length - st.onMission - st.slots }) });
  const checks = depot.staffChecks || ['chauffeurs', 'mecaniciens', 'caristes'];
  if (checks.includes('chauffeurs') && (staff.chauffeurs || 0) < vehicles.length) out.push({ level: 'warn', topic: 'rh', text: tStandalone('d3_coh_no_driver', { n: vehicles.length - (staff.chauffeurs || 0) }) });
  if (checks.includes('mecaniciens') && built.has('P11') && !staff.mecaniciens) out.push({ level: 'warn', topic: 'rh', text: tStandalone('d3_coh_no_mechanic') });
  if (checks.includes('caristes') && built.has('P3') && !staff.caristes) out.push({ level: 'warn', topic: 'rh', text: tStandalone('d3_coh_no_forklift') });
  if (vehicles.some((v) => v.status === 'atelier') && !built.has('P11')) out.push({ level: 'info', topic: 'flotte', text: tStandalone('d3_coh_external_garage') });
  return out;
}

export const fmtEur = (n) => (n === 0 ? tStandalone('d3_free') : new Intl.NumberFormat('fr-FR').format(n) + ' €');

// Placement dans l'arbre (colonne / rangée) — reprend la structure de l'écran actuel
export const TREE_LAYOUT = {
  P2: [2, 0], P3: [2, 1],
  P4: [0, 2], P5: [1, 2], EXT: [2, 2], P11: [3, 2], P14: [4, 2],
  P6: [0, 3], P7: [1, 3], P8: [2, 3], P9: [3, 3], P10: [4, 3],
  P12: [1, 4], P13: [3, 4],
};

// Si le jeu fournit `depot.available` (conditions réelles : CA, flotte, phase…), il fait foi.
export const nodeState = (id, built, tree = DEV_TREE, depot = null) => {
  if (built.has(id)) return 'built';
  if (depot && Array.isArray(depot.available)) return depot.available.includes(id) ? 'available' : 'locked';
  const n = tree.find((x) => x.id === id);
  return n && (n.requires || []).every((r) => built.has(r)) ? 'available' : 'locked';
};

// Étapes manquantes (dans l'ordre de construction) pour débloquer un nœud, et leur coût
export function unlockPath(id, built, tree = DEV_TREE) {
  const seen = new Set(); const path = [];
  const visit = (nid) => {
    if (seen.has(nid) || built.has(nid)) return;
    seen.add(nid);
    const n = tree.find((x) => x.id === nid);
    (n?.requires || []).forEach(visit);
    if (n) path.push(n);
  };
  visit(id);
  return { path, cost: path.reduce((a, n) => a + n.cost, 0), monthly: path.reduce((a, n) => a + (n.monthly || 0), 0) };
}

export function ancestors(id, tree = DEV_TREE) {
  const out = new Set();
  const visit = (nid) => (tree.find((x) => x.id === nid)?.requires || []).forEach((r) => { out.add(r); visit(r); });
  visit(id);
  return out;
}

// Étape conseillée : d'abord ce qui débloque un contrat actif, sinon la moins chère disponible
export function recommendNext(depot, tree = DEV_TREE) {
  const built = new Set(depot.built || []);
  const needed = (depot.contracts || []).map((c) => GOODS[c.goods]?.zone).filter((z) => z && !built.has(z));
  for (const z of needed) {
    const { path } = unlockPath(z, built, tree);
    if (path.length && nodeState(path[0].id, built, tree, depot) === 'available') {
      const c = depot.contracts.find((k) => GOODS[k.goods]?.zone === z);
      return { node: path[0], reason: tStandalone('d3_reco_unlocks', { zone: tree.find((n) => n.id === z)?.name, client: c.client }), target: z };
    }
  }
  const avail = tree.filter((n) => nodeState(n.id, built, tree, depot) === 'available').sort((a, b) => a.cost - b.cost);
  return avail[0] ? { node: avail[0], reason: tStandalone('d3_reco_cheapest') } : null;
}

export const contractsNeeding = (id, depot) => (depot.contracts || []).filter((c) => GOODS[c.goods]?.zone === id);
